import React from 'react';

export default function EventDesc(props) {

    const formatDate = (date, format) => {
		if (date) {
			var source = new Date(date);
			var offsetTime = new Date(source.valueOf() + 8 * 60 * 60 * 1000);
			var dateString = offsetTime.toISOString().substring(0, 10) + ' ';

			var hourString = offsetTime.getUTCHours();
			var minuteString = offsetTime.toISOString().substring(14, 16);
			var ampm = hourString >= 12 ? 'pm' : 'am';
			hourString = hourString % 12;
			hourString = hourString === 0 ? 12 : hourString;
			hourString = ('0' + hourString).slice(-2);
			var timeString = hourString + ':' + minuteString;

			if (format === 'en') {
				return dateString + timeString + ampm;
			} else if (format === 'chi') {
				return dateString + (ampm === 'pm' ? '下午' : '上午') + timeString;
			} else {
				return dateString;
			}
		}
    };

	return (
		<div className="border-bottom pb-3 mb-3">

			{props.remarkEn && <p dangerouslySetInnerHTML={{__html: props.remarkEn}}></p>}
			{props.socialMedia && <p>This event is only limited to applicants that have subscribed and followed below social media account(s).</p>}
			{props.socialMedia && <ul>
				{props.socialMediaAcName && <li><a href={props.socialMediaPath} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName}</a></li>}
				{props.socialMediaAcName2 && <li><a href={props.socialMediaPath2} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName2}</a></li>}
				{props.socialMediaAcName3 && <li><a href={props.socialMediaPath3} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName3}</a></li>}
				{props.socialMediaAcName4 && <li><a href={props.socialMediaPath4} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName4}</a></li>}
				{props.socialMediaAcName5 && <li><a href={props.socialMediaPath5} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName5}</a></li>}
				{props.socialMediaAcName6 && <li><a href={props.socialMediaPath6} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName6}</a></li>}
				{props.socialMediaAcName7 && <li><a href={props.socialMediaPath7} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName7}</a></li>}
				{props.socialMediaAcName8 && <li><a href={props.socialMediaPath8} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName8}</a></li>}

			</ul>}
			{
				!props.hide && <div>
					<p>Registration period: { formatDate(props.startTime, 'en') } to { formatDate(props.endTime, 'en') } (Hong Kong time)</p>
					{props.registrationRemarkEn && <p dangerouslySetInnerHTML={{__html: props.registrationRemarkEn}}></p>}
				</div>
			}
			<p>Successful applicants will receive an email confirmation with purchase details on {formatDate(props.emailDate)}. Unsuccessful applicant will not be notified separately.</p>
			<p className='font-weight-bold'>Pick-up period: {formatDate(props.pickUpDateFrom)} to {formatDate(props.pickUpDateTo)}</p>
			{props.pickUpRemarkEn && <p dangerouslySetInnerHTML={{__html: props.pickUpRemarkEn}}></p>}
			<span>Pick-up location:</span>
			<ul>
				{
					props.locations && props.locations.map((l, i) => (
						<li key={'enLoc' + i}>{l.addressEn}</li>
					))
				}
			</ul>
			{props.locationRemarkEn && <p dangerouslySetInnerHTML={{__html: props.locationRemarkEn}}></p>}
			<p>*Remarks:<br/>
			Each style can be applied once only.<br/>
			Repeated registration will be eliminated automatically.</p>
			<br />
				
			{props.remarkChi && <p dangerouslySetInnerHTML={{__html: props.remarkChi}}></p>}
			{props.socialMedia && <p>是次活動只限已訂閱以下社交平台的帳戶參加。</p>}
			{props.socialMedia && <ul>
				{props.socialMediaAcName && <li><a href={props.socialMediaPath} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName}</a></li>}
				{props.socialMediaAcName2 && <li><a href={props.socialMediaPath2} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName2}</a></li>}
				{props.socialMediaAcName3 && <li><a href={props.socialMediaPath3} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName3}</a></li>}
				{props.socialMediaAcName4 && <li><a href={props.socialMediaPath4} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName4}</a></li>}
				{props.socialMediaAcName5 && <li><a href={props.socialMediaPath5} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName5}</a></li>}
				{props.socialMediaAcName6 && <li><a href={props.socialMediaPath6} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName6}</a></li>}
				{props.socialMediaAcName7 && <li><a href={props.socialMediaPath7} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName7}</a></li>}
				{props.socialMediaAcName8 && <li><a href={props.socialMediaPath8} target="_blank" rel="noopener noreferrer" >{props.socialMediaAcName8}</a></li>}

			</ul>}
			{
			!props.hide && <div>
			<p>登記時間: {formatDate(props.startTime, 'chi')} 至 {formatDate(props.endTime, 'chi')} (香港時間)</p>
			{props.registrationRemarkChi && <p dangerouslySetInnerHTML={{__html: props.registrationRemarkChi}}></p>}
			</div>
			}
			<p>中籤者將於 {formatDate(props.emailDate)} 獲個別電郵通知購買詳情，未被抽中的參加者將不獲另行通知。</p>
			<p className='font-weight-bold'>取貨日期: {formatDate(props.pickUpDateFrom)} 至 {formatDate(props.pickUpDateTo)}</p>
			{props.pickUpRemarkChi && <p dangerouslySetInnerHTML={{__html: props.pickUpRemarkChi}}></p>}
			<span>取貨店鋪</span>
			<ul>
				{
					props.locations && props.locations.map((l, i) => (
						<li key={'chiLoc' + i}>{l.addressChi}</li>
					))
				}
			</ul>
			{props.locationRemarkChi && <p dangerouslySetInnerHTML={{__html: props.locationRemarkChi}}></p>}
			<p>*備註:<br/>
			每人每鞋款只可登記一次。<br/>
			重覆登記者將會自動取消資格。</p>
        </div>
    );
}
